import image01 from '../images/content-master/01.jpeg';
import imageWebp01 from '../images/content-master/01.webp';

import image02 from '../images/content-master/02.jpeg';
import imageWebp02 from '../images/content-master/02.webp';

import image03 from '../images/content-master/03.jpeg';
import imageWebp03 from '../images/content-master/03.webp';

import image04 from '../images/content-master/04.jpeg';
import imageWebp04 from '../images/content-master/04.webp';

import image05 from '../images/content-master/05.jpeg';
import imageWebp05 from '../images/content-master/05.webp';

import image06 from '../images/content-master/06.jpg';
import mago from '../images/content-master/Mago.jpeg';
import spaceWarrior from '../images/content-master/SpaceWarrior.jpg';

const contentMaster = [
	{
		id: '01',
		title: 'Personaje Estilizado',
		image: image06,
		imageWebp: image06,
		description:
			'Reuniremos 3 conceptos y generaremos nuestra propia versión de personajes para videojuegos.',
		video: 'https://www.youtube.com/watch?v=4lTnLeO3HB4&ab_channel=LIBELACADEMY',
	},
	{
		id: '02',
		title: 'Atsuko AAA',
		image: image01,
		imageWebp: imageWebp01,
		description:
			'Crea este excelente personaje AAA y aprende paso a paso el flujo para crear modelos nivel profesional.',
		video: 'https://www.youtube.com/watch?v=I2bpfjTQ2Rw',
	},
	{
		id: '03',
		title: 'Soldado AAA',
		image: image02,
		imageWebp: imageWebp02,
		description:
			'Usa las herramientas más usadas en la industria de los videojuegos y crea sorprendentes modelos AAA.',
		video: 'https://www.youtube.com/watch?v=I2bpfjTQ2Rw',
	},
	{
		id: '04',
		title: 'Iron Spider',
		image: image03,
		imageWebp: imageWebp03,
		description:
			'Aprende nuevas técnicas de procesos Hardsurface, en este proceso desarrollaremos la armadura.',
		video: 'https://www.youtube.com/watch?v=c7MEq3wdzOU',
	},
	{
		id: '05',
		title: 'Girl Hard Surface',
		image: image04,
		imageWebp: imageWebp04,
		description:
			'Realicemos este modelo anime Hard Surface y logra crear personaje femenino y estructuras inorgánicas.',
		video: 'https://www.youtube.com/watch?v=WKPrOlCX4kA',
	},
	{
		id: '06',
		title: 'Escultura CYBERPUNK',
		image: image05,
		imageWebp: imageWebp05,
		description: 'Sigue practicando y acelera el proceso de escultura con este fantástico modelo.',
		video: 'https://www.youtube.com/watch?v=qxzuW3ROTkM',
	},
	{
		id: '07',
		title: 'Mago',
		image: mago,
		imageWebp: mago,
		description:
			'Aprende ZBrush desde cero con un flujo de trabajo que te permitirá lograr tus primeras figuras digitales.',
		video: '',
	},
	{
		id: '08',
		title: 'Space Warrior',
		image: spaceWarrior,
		imageWebp: spaceWarrior,
		description: 'Crea este sorprendente personaje y domina la escultura Hardsurface en ZBrush.',
		video: '',
	},
];

export default contentMaster;
